module.exports = __webpack_public_path__ + "static/media/mobile_hero_allday_break_en.5b283b6e.jpg";